module.exports = __webpack_public_path__ + "media/images/sp/plans/button_deco_line-ec7ddb39d6e6573afa70860c38db0a89.svg";